import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import _Button from "../../generic/_Button";

const isJson = (str) => {
  try {
    return typeof str === "string" ? JSON.parse(str) : str;
  } catch {
    return null;
  }
};

const isValidUrl = (url = "") => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

const _ModalViewer = ({ visible, onClose, data }) => {
  const [snapshot, setSnapshot] = useState(null);

  useEffect(() => {
    if (visible) {
      setSnapshot(isJson(data));
    }
  }, [visible, data]);

  const fileUri = snapshot?.fileUri || snapshot?.url || null;

  const canRenderImage = useMemo(() => {
    return isValidUrl(fileUri);
  }, [fileUri]);

  const _onClose = () => {
    if (onClose) onClose();
  };

  return (
    <Modal show={visible} onHide={_onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>

      <Modal.Body className="flex items-center justify-center bg-black/80 p-2">
        {canRenderImage ? (
          <div className="w-full max-w-3xl h-[70vh] flex items-center justify-center">
            <img
              src={fileUri}
              alt="preview"
              className="max-h-full max-w-full object-contain rounded"
            />
          </div>
        ) : (
          <div className="text-sm text-gray-300 break-all text-center px-4">
            {fileUri || "Sin contenido válido"}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <_Button title="Cerrar" style="none" onClick={_onClose} />
      </Modal.Footer>
    </Modal>
  );
};

_ModalViewer.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default _ModalViewer;
